import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import PerfectScrollbar from "react-perfect-scrollbar";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import Footer from "../shared/Footer";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SettingControlForm = () => {
  const [existing, setExisting] = useState(null);
  const [form, setForm] = useState({
    timeout_duration: "",
    max_upload_size: "",
    max_upload_limit: "",
    max_upload_capacity: "",
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (k, d) => translations[k] || d;

  /* ⇢ ayarları getir */
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/settings`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
      })
      .then((r) => {
        setExisting(r.data);
        setForm({
          timeout_duration: r.data.timeout_duration ?? "",
          max_upload_size: r.data.max_upload_size ?? "",
          max_upload_limit: r.data.max_upload_limit ?? "",
          max_upload_capacity: r.data.max_upload_capacity ?? "",
          category_image_width: r.data.category_image_width ?? "",
          category_image_height: r.data.category_image_height ?? "",
          brand_image_width: r.data.brand_image_width ?? "",
          brand_image_height: r.data.brand_image_height ?? "",
          product_list_image_width: r.data.product_list_image_width ?? "",
          product_list_image_height: r.data.product_list_image_height ?? "",
          product_gallery_image_width: r.data.product_gallery_image_width ?? "",
          product_gallery_image_height:
            r.data.product_gallery_image_height ?? "",
        });
      })
      .catch((e) => {
        console.error(e);
        toast.error(getText("SETTINGS_FETCH_ERROR"));

      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) setForm({ ...form, [name]: value });
  };

  const handleSave = async () => {
    if (!existing) return;

    /* 🔑 sadece değişen alanları hazırla */
    const dirty = Object.keys(form).reduce((acc, k) => {
      if (String(form[k]) !== String(existing[k])) acc[k] = form[k];
      return acc;
    }, {});

    if (Object.keys(dirty).length === 0) {
      toast.info(getText("NO_CHANGES"));

      return;
    }

    try {
      await axios.put(`${BASE_URL}/api/settings/1`, dirty, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
      });
      toast.success(getText("SETTINGS_SAVED_SUCCESS"));

      setExisting({ ...existing, ...dirty }); // referans güncelle
    } catch (e) {
      console.error(e);
      toast.error(getText("SETTINGS_SAVE_ERROR"));

    }
  };

  if (!existing) return null; // yükleniyor…

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card">
            <div className="card-body">
              {/* timeout */}
              <div className="mb-4">
                <label className="form-label fw-bold">
                  {getText(
                    "LABEL_TIMEOUT_DURATION"
                  )}
                </label>
                <input
                  type="number"
                  name="timeout_duration"
                  className="form-control"
                  value={form.timeout_duration}
                  onChange={handleChange}
                  min="1"
                  max="999"
                />
              </div>

              {/* upload size */}
              <div className="mb-4">
                <label className="form-label fw-bold">
                  {getText(
                    "LABEL_MAX_UPLOAD_SIZE"
                  )}
                </label>
                <input
                  type="number"
                  name="max_upload_size"
                  className="form-control"
                  value={form.max_upload_size}
                  onChange={handleChange}
                  min="1"
                  max="100"
                />
              </div>
              <div className="mb-4">
                <label className="form-label fw-bold">
                  {getText(
                    "LABEL_MAX_UPLOAD_CAPACITY"
                  )}
                </label>
                <input
                  type="number"
                  name="max_upload_capacity"
                  className="form-control"
                  value={form.max_upload_capacity}
                  onChange={handleChange}
                  min="10"
                  max="1024"
                />
                <small className="text-muted">
                  {getText(
    "TOTAL_UPLOAD_CAPACITY_INFO"
  )}
                </small>
              </div>


              <div className="d-flex justify-content-center mt-4">
                <button className="btn btn-primary" onClick={handleSave}>
                  <FiSave className="me-2" />
                  {getText("SAVE_BTN")}
                </button>
              </div>
            </div>
          </div>
        </div>
        
      </PerfectScrollbar>
    </div>
  );
};

export default SettingControlForm;
